import React from "react";

const URL_SPLIT = /(https?:\/\/[^\s]+)/gi;

export interface LinkifiedPlainTextProps {
  text: string;
  className?: string;
  linkClassName?: string;
}

/**
 * Renders plain text with http(s) URLs as clickable links.
 * Parent should use `whitespace-pre-line` if the text contains newlines (`\n`).
 */
export function LinkifiedPlainText({
  text,
  className,
  linkClassName = "text-primary underline break-words",
}: LinkifiedPlainTextProps) {
  if (!text) {
    return null;
  }
  const parts = text.split(URL_SPLIT);
  return (
    <span className={className}>
      {parts.map((part, i) =>
        /^https?:\/\//i.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            {part}
          </a>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </span>
  );
}
